import { CreditScore } from '../types';
import { cn } from '@/shadcn-ui/utils';
import { AgeRange } from '../types/age-range';

export interface CreditAgeSummaryProps {
  selectedCreditScoreId?: string;
  selectedIsOver25: boolean;
  selectedAgeRangeId?: string;
  creditScores: CreditScore[];
  ageRanges?: AgeRange[];
  defaultText?: string;
  className?: string;
}

export default function CreditAgeSummary({
  selectedCreditScoreId,
  selectedIsOver25,
  selectedAgeRangeId,
  creditScores,
  ageRanges,
  defaultText = 'Please select a credit score',
  className,
}: CreditAgeSummaryProps) {
  const selectedCreditScore = creditScores.find(
    (score) => score.id === selectedCreditScoreId
  )?.range;

  const displayAge = (() => {
    if (!ageRanges) {
      return selectedIsOver25 ? '25+' : 'under 25';
    }

    return ageRanges.find((range) => range.id === selectedAgeRangeId)?.display_name;
  })();

  return (
    <p
      className={cn(
        'body2 footer pointer-events-auto text-center transition-all duration-100',
        className
      )}
    >
      {selectedCreditScore === undefined
        ? defaultText
        : `Prices based on age (${displayAge}) & credit (${selectedCreditScore})`}
    </p>
  );
}
